var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',{staticClass:"buttonsWrap",attrs:{"type":"flex","justify":"space-between"}},[_c('div',{staticClass:"buttonsWrap-left"},[_vm._t("default")],2),_c('div',{staticClass:"buttonsWrap-right"},[_vm._t("right")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }